import React from "react";
import { ProcessStepProps } from "./types";

const ProcessStep: React.FC<ProcessStepProps> = ({
  number,
  title,
  description,
}) => (
  <div className="step">
    <div className="step-number">{number}</div>
    <h3>{title}</h3>
    <p>{description}</p>
  </div>
);

const Process: React.FC = () => {
  const steps = [
    {
      number: 1,
      title: "Comparte tu Casa",
      description: "Sube tus datos y fotos.",
    },
    {
      number: 2,
      title: "Conócenos",
      description: "Hablamos para conocernos y entender tu proyecto.",
    },
    {
      number: 3,
      title: "Visita y Sueños",
      description: "Te visitamos y compartimos nuestra visión familiar.",
    },
    {
      number: 4,
      title: "Negociación Transparente",
      description: "Tratamos con honestidad y cercanía.",
    },
    {
      number: 5,
      title: "Nueva Comunidad",
      description: "Sumas vida nueva y arraigo al entorno rural.",
    },
  ];

  return (
    <section id="proceso" className="process">
      <div className="container">
        <h2>Cómo Funciona</h2>
        <div className="process-steps">
          {steps.map((step) => (
            <ProcessStep
              key={step.number}
              number={step.number}
              title={step.title}
              description={step.description}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
